<template>
  <div class="pageStyle">
    <div class="header">
      <img
        src="https://static.xchengtech.cn/7d74bd9c9bd0437b936d0af4b4982ea1.png"
        alt=""
      />
    </div>
    <div class="content">
      <div class="item-box">
        <div class="item" v-for="(item, index) in dataList" :key="index">
          <div class="item-title">
            <div>
              <van-icon name="circle" />
              <span>{{ item.title }}</span>
            </div>
            <div>
              <span>{{ parseDay(item.createDateTime) }}</span>
            </div>
          </div>
          <div class="item-describe">
            {{ item.content }}
          </div>
          <div class="item-to"  v-show="item.url">
            <span @click="toUrl(item.url)">查看详情</span>
            <van-icon name="arrow" @click="toUrl(item.url)" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Icon, Toast } from "vant";
import { parseDay } from "@/utils/index.js";
import { getProductList, getAllXcProductNews } from "@/api/product.js";
Vue.use(Toast);
Vue.use(Icon);
export default {
  mounted() {
    Toast.loading({
      duration: 0, // 持续展示 toast
      forbidClick: true,
      message: "加载中",
    });
    getAllXcProductNews().then((newsRes) => {
      let o = newsRes.filter((item) => {
        return !item.productId;
      });
      this.dataList = o.sort((a, b) => {
        return b.createDateTime - a.createDateTime;
      });
      Toast.clear();
    });
  },
  data() {
    return {
      dataList: [],
    };
  },
  methods: {
    parseDay,
    toUrl(url) {
      window.location.href = url;
    },
  },
};
</script>

<style scoped>
.pageStyle {
  min-height: 100vh;
  background-color: #f7f7f9;
}
.header {
  margin-bottom: 3vw;
}
.header img {
  display: block;
  width: 100%;
}
.content {
}

.content .item-box {
  padding-bottom: 3vw;
  margin: 0 3vw 3vw;
  display: grid;
  gap: 3vw;
}
.content .item-box .item {
  padding: 3vw;
  border-top: 3px solid #c41300;
  background-color: white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border-radius: 0 0 4px 4px;
}
.content .item-title {
  /* padding: 2vw 0; */
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
.item-title .van-icon {
  font-weight: 900;
  color: #c41300;
  font-size: 3.2vw;
}
.content .item-title div:nth-of-type(1) {
  display: flex;
  align-items: center;
  gap: 2vw;
}
.content .item-title div:nth-of-type(1) span {
  font-size: 4.2vw;
}
.content .item-title div:nth-of-type(2) span {
  color: #bcbcbc;
  font-size: 3.6vw;
  white-space: nowrap;
}
.item-describe {
  text-indent: 5.4vw;
  padding-top: 2vw;
  font-size: 3.6vw;
  color: #6d6d6d;
  line-height: 7vw;
}
.item-to {
  padding-top: 1vw;
  text-align: right;
  font-size: 3.6vw;
  color: #c41300;
}
</style>


// WEBPACK FOOTER //
// src/view/newsList/index.vue